import React from "react";
import { UscTrackingLocation } from "../../../utils/tracking";
import PdfButton from "./basket/common/PdfButton";
import SaveToMyToyotaButton from "./basket/common/SaveToMyToyotaButton";
import BasketVehicleCode from "./basket/content/BasketVehicleCode";
import * as Styles from "./AdditionalCtas.styles";
import Text from "../../../../shared-components/toyota/styles/atoms/Text";
import { useUscLabel } from "../../../utils/labels";

const AdditionalCtas = (): JSX.Element => {
    const saveThisConfigurationLabel = useUscLabel("uscSaveThisConfiguration");

    return (
        <Styles.Wrapper>
            <Text tag="h2" variant="h4">
                {saveThisConfigurationLabel}
            </Text>
            <Styles.Ctas>
                <PdfButton buttonVariant="basket-cta" trackingLocation={UscTrackingLocation.Extras} />
                <SaveToMyToyotaButton buttonVariant="basket-cta" trackingLocation={UscTrackingLocation.Extras} />
                <BasketVehicleCode />
            </Styles.Ctas>
        </Styles.Wrapper>
    );
};

export default AdditionalCtas;
